import React from 'react';
import './inquiryDetails.css';

const InquiryDetails = () => {
  // Sample inquiry data
  const inquiry = {
    id: 1001,
    name: 'John Doe',
    email: 'john@example.com',
    phone: '+1 234 567 890',
    subject: 'Car Availability',
    message: 'Hello, I would like to inquire about the availability of the Tesla Model 3 in red color. Do you have it in stock currently? Also, what would be the estimated delivery time if I place an order today?',
    date: '2023-06-15 09:30',
    status: 'Pending',
    responses: [
      {
        id: 1,
        responder: 'Admin User',
        message: 'We have received your inquiry and will get back to you within 24 hours.',
        date: '2023-06-15 10:15',
      }
    ]
  };

  return (
    <div className="inquiry-details">
      <div className="details-header">
        <h2>Inquiry #{inquiry.id}</h2>
        <div className="status-container">
          <span className={`status-badge ${inquiry.status.toLowerCase()}`}>
            {inquiry.status}
          </span>
          <button className="status-btn">Update Status</button>
        </div>
      </div>
      
      <div className="inquiry-info">
        <div className="customer-details">
          <h3>Customer Information</h3>
          <div className="detail-row">
            <span className="detail-label">Name:</span>
            <span className="detail-value">{inquiry.name}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Email:</span>
            <span className="detail-value">{inquiry.email}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Phone:</span>
            <span className="detail-value">{inquiry.phone}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Date:</span>
            <span className="detail-value">{inquiry.date}</span>
          </div>
        </div>
        
        <div className="inquiry-content">
          <h3>Subject: {inquiry.subject}</h3>
          <div className="message-box">
            <p>{inquiry.message}</p>
          </div>
        </div>
      </div>
      
      <div className="response-section">
        <h3>Responses</h3>
        {inquiry.responses.length > 0 ? (
          <div className="responses-list">
            {inquiry.responses.map(response => (
              <div key={response.id} className="response-item">
                <div className="response-header">
                  <span className="responder-name">{response.responder}</span>
                  <span className="response-date">{response.date}</span>
                </div>
                <div className="response-message">
                  <p>{response.message}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-responses">No responses yet.</p>
        )}
        
        <div className="response-form">
          <h4>Add Response</h4>
          <textarea 
            className="response-textarea" 
            placeholder="Type your response here..."
            rows="5"
          ></textarea>
          <div className="form-actions">
            <button className="send-btn">Send Response</button>
            <button className="cancel-btn">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InquiryDetails;